import { UntilDestroy } from '@ngneat/until-destroy';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AudienceBuilderService } from '../audience-builder/audience-builder.service';
import { DataType } from '../enums/data-types';
import { FetchDataTypeOperators } from '../audience-builder/audience-builder.actions';
import { selectDataTypeOperators } from '../audience-builder/audience-builder.reducer';
import { Store } from '@ngrx/store';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
class AudienceDefinitionResolverService {

  constructor(public builderService: AudienceBuilderService, private store: Store, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    this.store.select(selectDataTypeOperators).subscribe(dataTypeOperators => {
      if (!dataTypeOperators || !dataTypeOperators.length) {
        this.store.dispatch(new FetchDataTypeOperators(route.params['contextId'], route.params['dataUniverseId']))
      }
    });


    const currentNavigation = this.router.getCurrentNavigation();
    const audienceData = currentNavigation?.extras?.state?.['audienceData'];

    if (audienceData) {
      currentNavigation.extras.state['audienceData'] = undefined;
      return of(audienceData);
    }

    return this.builderService.fetchCabAttributeDetails(
      DataType.AUDIENCE_DEFINITION,
      route.params['contextId'],
      route.params['dataUniverseId'],
      route.params['definitionId']
    );
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AudienceDefinitionResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot): Observable<any> => {
  return inject(AudienceDefinitionResolverService).resolve(route);
}
